import type { TableColumnType } from 'antd';
import type { ProdutoFornecedor } from '@/features/produto/types/ProdutoFornecedor';
import { formatDocument, numberToCurrency, numberToDecimal } from '@/std/format';

export const columns: TableColumnType<ProdutoFornecedor>[] = [
    {
        dataIndex: 'prf_fornecedor_razao_social',
        sorter: true,
        title: 'Fornecedor',
    },
    {
        align: 'center',
        dataIndex: 'prf_fornecedor_cnpj_cpf',
        render: (v) => formatDocument(v),
        sorter: true,
        title: 'Documento',
        width: '10rem',
    },
    {
        align: 'center',
        dataIndex: 'prf_compra_data',
        sorter: true,
        title: 'Data da compra',
        width: '10rem',
    },
    {
        align: 'center',
        dataIndex: 'prf_fornecedor_produto_codigo',
        sorter: true,
        title: 'Código do produto',
        width: '10rem',
    },
    {
        dataIndex: 'prf_produto',
        sorter: true,
        title: 'Nome do Produto',
    },
    {
        align: 'center',
        dataIndex: 'prf_cod_barra',
        sorter: true,
        title: 'Cód. barras',
        width: '10rem',
    },
    {
        align: 'center',
        dataIndex: 'prf_unidade',
        sorter: true,
        title: 'Und.',
        width: '6rem',
    },
    {
        align: 'right',
        dataIndex: 'prf_quantidade',
        render: (value) => numberToDecimal(value),
        sorter: true,
        title: 'Quantidade',
        width: '10rem',
    },
    {
        align: 'right',
        dataIndex: 'prf_preco_custo',
        render: (value) => numberToCurrency(value),
        sorter: true,
        title: 'Preço de custo',
        width: '10rem',
    },
];
